import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject, ViewChild, AfterViewInit, QueryList, ViewChildren, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BizEntityChildrenStatusStoreService, FormBaseEntityComponent } from '@optima-stride-ai/optima-app-framework';
import { ModalButtonIDs } from '../../biz-entity/form-base-entity/form-base-entity.component';
import { AdditionalInfoComponent } from '@optima-stride-ai/optima-app-framework';
import { FormLayoutComponent, IFormLayout, IFormLayoutContent, IFormLayoutFooter, IFormLayoutHeader, IPolymorphicControlMeta, PolymorphicControlService, PolyMorphicControlTypes, IListView, IListViewItem, ListerComponent, ToastService, ProgressIndicatorComponent, ProcessProgressType, ProcessProgressView, ShimmerVariant, iProcessProgress } from '@optima-stride-ai/optima-components';
import { IAdditionalInfo, IRelationshipConfiguration, FieldTypes, IFieldMeta, IBizEntityRelationships, IBizEntityRelationTarget, RelationshipTargetType, RelationshipLinkType, IBizEntityType, BizEntityTypeCategory } from '@optima-stride-ai/core';
import { FormModule, CardComponent, CardBodyComponent, CardHeaderComponent } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { IMeasure, IMeasureSource, KPIAndMeasureCategories, MeasureSources, ConnectionPollingModes, groupsMenuItems, categoriesMenuLabel, Discipline } from '../measure.model';
import { initFormStateFunc } from '../../utils/form/function-init-form-state';
import { AppStateService } from '../../state/app-state';
import { notifyStrategyEntityCreated } from '../../strategy/strategy-explorer/strategy-explorer-creation';
import { measureDataSyncBeforeSendingToAPI, MeasuresStateStoreService } from '../measure-state-store/measures-state-store.service';
import { IBizEntity } from '@optima-stride-ai/core';
import { FormFieldsComponent } from '../../form-fields/form-fields.component';
import { FormRelationshipFieldsComponent } from '@optima-stride-ai/optima-app-framework';
import { BizEntityTypeStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { IDataSource, getSourcesListView } from './sources-list-view';
import { getAdditionalFieldsListView } from './additional-fields-list-view';
import { OptimaDefaultModalService } from '../../modal/modal.service';
import { GetDefaultConfig, ModalDialogs } from '../../modal/modal';
import { AppRootStateStoreService, benBizEntitySyncBeforeSendingToAPI, BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { IBenBizEntity } from '../../../models/interfaces/biz-entity.model';
import { RelationshipStateStoreService, AppFrameworkContextService, IXappCap } from '@optima-stride-ai/optima-app-framework';
import { AutoCreateEntitiesService } from '../../kpi/auto-create-entites';
import { TenantStateStoreService, UserContextService } from '@optima-stride-ai/optima-platform';
import { MeasureExplorerComponent } from '../measure-explorer/measure-explorer.component';

@Component({
  selector: 'app-form-measure',
  imports: [CommonModule, FormBaseEntityComponent, AdditionalInfoComponent, FormLayoutComponent, ReactiveFormsModule, FormModule, IconModule, ListerComponent, FormRelationshipFieldsComponent, CardComponent, CardBodyComponent, CardHeaderComponent, ProgressIndicatorComponent],
  templateUrl: './form-measure.component.html',
  styleUrl: './form-measure.component.sass',
})
export class FormMeasureComponent implements OnInit, AfterViewInit {
  @ViewChild('baseEntityForm') baseEntityFormComponent!: FormBaseEntityComponent;
  @ViewChild('additionalInfoForm') additionalInfoFormComponent!: AdditionalInfoComponent;
  @ViewChild('formFields') formFieldsComponent!: FormFieldsComponent;
  @ViewChildren('relationshipFields') relationshipFieldsComponents!: QueryList<FormRelationshipFieldsComponent>;

  formLayout: IFormLayout = { 
    header: { title: '' }, 
    content: { fieldItems: [] }, 
    footer: { actions: [] } 
  };
  formFooterLayout: IFormLayout = { 
    header: { title: '' }, 
    content: { fieldItems: [] }, 
    footer: { actions: [] } 
  };
 
  measureBizEntity!: IMeasure;
  isEditing: boolean = false;
  protected isFormLoading = true;
  private baseFormReady = false;
  private flowDataReady = false;
  protected readonly formLoadingProgress: iProcessProgress = { id: 'form-measure-loading', type: ProcessProgressType.Indeterminate };
  protected readonly ProcessProgressView = ProcessProgressView;
  protected readonly ShimmerVariant = ShimmerVariant;
  private isAPICallInProgress: boolean = false;
  private discipline!: string;

  get formHeaderTitle(): string {
    return this.measureBizEntity?.type?.name || 'Measure';
  }

  get formHeaderSubtitle(): string {
    const typeName = this.measureBizEntity?.type?.name || 'Measure';
    const entityName = this.measureBizEntity?.name || typeName;
    return this.isEditing
      ? `Edit ${entityName} to track strategy`
      : `Create ${typeName} to track strategy`;
  }
  
  // Once filter is avaliable this will all be handled by the generic explorer
  // This is a temporary solution until the generic explorer has filter capabilities
  private selectedParentEntity?: IBizEntity;
  readonly parentExplorer = {
    component: MeasureExplorerComponent,
    inputs: {
      isInModal: true,
      onSelectionChange: (data: IBizEntity | undefined) => {
        this.selectedParentEntity = data;
      }
    },
    data: () => this.selectedParentEntity ?? this.baseEntityFormComponent?.selectedBizEntityObj ?? undefined,
  };
  // Once filter is avaliable this will all be handled by the generic explorer
  // This is a temporary solution until the generic explorer has filter capabilities
  
  /**
   * To Do
   * need to remove this sources related code as sources are currently hardcoded.
   */
  // Data sources for the table
  sources: IMeasureSource[] = [
    {
      connection: {
        id: '1',
        tenantId: '',
        appId: '',
        source: MeasureSources.MANUAL,
        name: 'Manual Entry',
        connectionConfig: {},
        pollingMode: ConnectionPollingModes.POLL,
        pollingFrequencySeconds: 0
      },
      source: MeasureSources.MANUAL,
      apiEndpoint: 'abc'
    }
  ];

  sourcesListView: IListView<IDataSource> = {
    title: 'Data Sources',
    colHeaders: [
      { key: "col1", label: "#", cssClass: "index-label" },
      { key: "col2", label: "Icon", cssClass: "icon-label" },
      { key: "col3", label: "Source Name", cssClass: "name-label" },
      { key: "col4", label: "Active", cssClass: "active-label" },
      { key: "col5", label: "Actions", cssClass: "actions-label" }
    ],
    items: [],
    isStriped: true,
  };

  additionalFieldsListView: IListView<any> = {
    title: '',
    colHeaders: [
      { key: "col1", label: "#", cssClass: "index-label" },
      { key: "col2", label: "Icon", cssClass: "icon-label" },
      { key: "col3", label: "Field Name", cssClass: "name-label" },
      { key: "col4", label: "", cssClass: "spacer-label" },
      { key: "col5", label: "Actions", cssClass: "actions-label" }
    ],
    items: [],
    isStriped: true,
  };

  private readonly polymorphicControlService = inject(PolymorphicControlService);
  private readonly appStateService = inject(AppStateService);
  private readonly measureStateStoreService = inject(MeasuresStateStoreService);
  private readonly bizEntityTypesStateStoreService: BizEntityTypeStateStoreService = inject(BizEntityTypeStateStoreService);
  private readonly bizEntityStateStoreService: BizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly appRootStateStoreService = inject(AppRootStateStoreService);
  private readonly toastService = inject(ToastService);
  private readonly modalService = inject(OptimaDefaultModalService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly relationshipStateStoreService = inject(RelationshipStateStoreService);
  private readonly autoCreateEntitiesService = inject(AutoCreateEntitiesService);
  private readonly bizEntityChildrenStatusStoreService = inject(BizEntityChildrenStatusStoreService);
  private readonly appFrameworkContextService = inject(AppFrameworkContextService);
  private readonly tenantStateStoreService = inject(TenantStateStoreService);
  private readonly userContextService = inject(UserContextService);
  
  bizEntities: IBizEntity[] = [];
  relationshipConfigurations: IRelationshipConfiguration[] = [];
  relationshipAdditionalInfo: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}[] = []; 
  relationshipAdditionalInfoForEdit: {config: IRelationshipConfiguration, bizEntity: IBizEntity}[] = [];
  extractedTargetBizEntities: IBizEntity[] = [];
  private currentAppId: string | undefined;

  constructor() {
    let state = initFormStateFunc(this.appStateService);
    this.measureBizEntity = state.bizEntity as IMeasure;
    this.isEditing = state.isEditing;
  }

  ngOnInit(): void {
    if (!this.currentAppId) {
      this.currentAppId = this.appFrameworkContextService.currentAppId;
    }
    this.doesBizEntityHaveRelationship();
    this.initializeAdditionalFieldsListView();
    if (this.isEditing) {
      this.loadMeasureData();
    } else {
      // In create mode, check if there's a context entity from which create was triggered
      const contextEntity = this.appStateService.selectedBizEntityForEdit;
      
      this.initializeForm();
      
      // If there's a context entity, set it as parent
      if (contextEntity?.id) {
        this.measureBizEntity.parentId = contextEntity.id.toString();
      }
      
      this.markFlowDataReady();
    }
  }

  private markFlowDataReady(): void {
    this.flowDataReady = true;
    this.tryHideFormLoading();
  }

  private tryHideFormLoading(): void {
    if (this.baseFormReady && this.flowDataReady) {
      this.isFormLoading = false;
    }
  }

  onFormReady(): void {
    this.baseFormReady = true;
    this.tryHideFormLoading();
  }

  private initializeAdditionalFieldsListView(): void {
    // TODO: Remove this block once Dynamic Query Rule (DQR, formerly BizRule) is implemented.
    // Currently, the KPI bizRule is static and expects the 'status' field to exist.
    // This ensures the status field is auto-added for new measures until DQR allows dynamic field configuration.
    // ======================================================================
    // if(!this.isEditing){
    //   let checkIfStatusNameFieldExists = this.measureBizEntity.logFieldsMeta?.some(field => field.name === 'status');
    //   if(!checkIfStatusNameFieldExists){
    //     const statusField: IFieldMeta = defaultStatusMeasureLogFieldsMeta;
    //     this.measureBizEntity.logFieldsMeta = [...(this.measureBizEntity.logFieldsMeta || []), statusField];
    //   }
    // }
    // ======================================================================
    const fields = this.measureBizEntity?.logFieldsMeta || [];
    this.additionalFieldsListView = getAdditionalFieldsListView(
      fields,
      (item) => this.onFieldSettingsClick(item),
      (item) => this.onFieldDeleteClick(item)
    );
    this.cdr.markForCheck();
  }

  private loadMeasureData(): void {
    this.measureStateStoreService.getState(this.bizEntityTypesStateStoreService, [this.measureBizEntity?.id])
      .then((response) => {
        this.measureBizEntity = response?.[0] as IMeasure;
         if (this.doesBizEntityHaveRelationship()) {
            this.relationshipStateStoreService.getState([this.measureBizEntity?.id?.toString()], this.bizEntityTypesStateStoreService, this.bizEntityStateStoreService, this.bizEntityChildrenStatusStoreService, true).then((relationships) => {
              if (relationships) {
                this.extractedTargetBizEntities = this.extractTargetBizEntities(relationships);
              } 
              this.markFlowDataReady();
            }).catch(() => {
              this.markFlowDataReady();
            });
          } else {
            this.markFlowDataReady();
          }
        this.initializeAdditionalFieldsListView();
        this.initializeForm();
      }).catch(() => {
        this.markFlowDataReady();
      });
  }

  private initializeForm(): void {
    this.buildFormLayout();
    this.formFooterLayout = this.buildFormFooterLayout();
  }

  ngAfterViewInit(): void {
  }


  private buildFormLayout() {
    const layout: IFormLayout = {
      content: this.buildFormLayoutContent(),
      cssClass: 'ben-form-measure-specific'
    };
    this.formLayout = layout;
  }


  private buildFormLayoutContent(): IFormLayoutContent {
    return {
      fieldItems: this.buildFormFields()
    };
  }

  private buildFormFooterLayout(): IFormLayout {
    const layoutFooterContent: IFormLayoutContent = {
      fieldItems: [],
    };
    const layoutFooter: IFormLayoutFooter = {
      actions: [{
        label: this.isEditing ? `Update ${this.measureBizEntity?.name}` : `Create ${this.measureBizEntity?.type?.name}`,
        icon: this.isEditing ? 'cilCheckAlt' : 'cilPlus',
      }]
    };
    const layoutFooterMain: IFormLayout = {
      content: layoutFooterContent,
      footer: layoutFooter,
      cssClass: 'ben-form-measure-footer'
    };
    return layoutFooterMain;
  }

  private buildFormFields(): IPolymorphicControlMeta[] {
    const fields: IPolymorphicControlMeta[] = [];

    const discipline: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'discipline',
      type: PolyMorphicControlTypes.options,
      label: 'Discipline',
      icon: 'cilFolder',
      value: Discipline["SoftwareEngineering"] || '',
      optionSelected: Discipline["SoftwareEngineering"],
      optionHeader: 'Select Discipline',
      optionsWithIcon: this.getDisciplineOptions(),
      disabled: true,
      placeholder: 'Select discipline',
      fieldMeta: {
        id: 'discipline',
        name: 'Discipline',
        type: FieldTypes.text,
        label: ' Discipline Field',
        isRequired: true,
      }
    });

    const group: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'group',
      type: PolyMorphicControlTypes.options,
      label: 'Group',
      icon: 'cilLibrary',
      value: this.measureBizEntity?.group || '',
      optionHeader: 'Select Group',
      optionsWithIcon: this.getGroupOptions(),
      optionSelected: this.measureBizEntity?.group || '',
      placeholder: 'Select group',
      fieldMeta: {
        id: 'group',
        name: 'Group',
        type: FieldTypes.text,
        label: ' Group Field',
        isRequired: true,
      }
    });

    const subGroup: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'sub-group',
      type: PolyMorphicControlTypes.options,
      label: 'Sub Group',
      icon: 'cilLayers',
      value: this.measureBizEntity?.subGroup || '',
      optionHeader: 'Select Sub Group',
      optionsWithIcon: this.getSubGroupOptions(),
      optionSelected: this.measureBizEntity?.subGroup || '',
      placeholder: 'Select sub group',
      fieldMeta: {
        id: 'sub-group',
        name: 'Sub Group',
        type: FieldTypes.text,
        label: ' Sub Group Field',
        isRequired: true,
      }
    });


        const category: IPolymorphicControlMeta = this.polymorphicControlService.getC({
          id: 'category',
          type: PolyMorphicControlTypes.options,
          label: 'Category',
          icon: 'cilTags',
          value: this.measureBizEntity?.category || '',
          optionSelected: this.measureBizEntity?.category || '',
          optionHeader: 'Select Category',
          optionsWithIcon: this.getCategoryOptions(),
          placeholder: 'Select category',
          fieldMeta: {
            id: 'category',
            name: 'Category',
            type: FieldTypes.text,
            label: ' Category Field',
            isRequired: true,
          }
        });

    fields.push(discipline);
    fields.push(group);
    fields.push(subGroup);
    fields.push(category);

    return fields;
  }

  get isFormValid(): boolean {
    // Validate base entity form (name, description, icon, etc.)
    if (!this.baseEntityFormComponent?.isBaseFormValid) {
      return false;
    }

    // Validate measure specific fields
    if (this.formLayout?.content?.fieldItems) {
      for (const field of this.formLayout.content.fieldItems) {
        if (field.fieldMeta?.isRequired) {
          const fieldValue = field.type === PolyMorphicControlTypes.options 
            ? field.optionSelected 
            : field.value;

          field.touched = true;

          // Check if field is empty
          if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
            return false;
          }

          // Check if field has inputPattern validation
          if (field.fieldMeta.inputPattern && fieldValue) {
            const pattern = new RegExp(field.fieldMeta.inputPattern);
            if (!pattern.test(fieldValue.toString())) {
              return false;
            }
          }
        }
      }
    }

   if(this.measureBizEntity?.type?.additionalFields?.length > 0){
      const isAdditionalInfoValid = this.additionalInfoFormComponent?.isAdditionalInfoValid || false;
      if (!isAdditionalInfoValid) {
        return false;
      }
    }

    if (this.relationshipFieldsComponents?.length > 0) {
      const allRelationshipsValid = this.relationshipFieldsComponents.toArray().every(rf => rf.isFormValid());
      if (!allRelationshipsValid) {
        return false;
      }
    }

    return true;
  }

   get KPIAndMeasureCategories() {
    return KPIAndMeasureCategories;
  }

  get KPIAndMeasureCategoriesArray() {
    return Object.keys(KPIAndMeasureCategories)
      .filter(key => isNaN(Number(key)))  // Remove numeric keys
      .map(key => key);  // Return the enum names (strings)
  }

  private populateMeasureFormWithValues(): IMeasure {
    this.measureBizEntity.name = this.baseEntityFormComponent?.bizEntityFormValues?.name;
    this.measureBizEntity.description = this.baseEntityFormComponent?.bizEntityFormValues?.description;
    this.measureBizEntity.icon = this.baseEntityFormComponent?.bizEntityFormValues?.icon;
    this.measureBizEntity.parentId = this.baseEntityFormComponent?.bizEntityFormValues?.parentId;
    this.measureBizEntity.ownerId = this.baseEntityFormComponent?.bizEntityFormValues?.ownerId;
    this.discipline = this.formLayout.content?.fieldItems?.find(field => field.id === 'discipline')?.optionSelected || '';
    this.measureBizEntity.group = this.formLayout.content?.fieldItems?.find(field => field.id === 'group')?.optionSelected || '';
    this.measureBizEntity.subGroup = this.formLayout.content?.fieldItems?.find(field => field.id === 'sub-group')?.optionSelected || '';
     const category = this.formLayout.content?.fieldItems?.find(field => field.id === 'category')?.optionSelected || '';
     this.measureBizEntity.category = KPIAndMeasureCategories[category as keyof typeof KPIAndMeasureCategories];
    this.measureBizEntity.additionalInfo = this.additionalInfoFormComponent?.additionalInfoFormValues || [];
    this.measureBizEntity.logFieldsMeta = this.measureBizEntity?.logFieldsMeta || [];
    this.measureBizEntity.source = this.measureBizEntity?.source || this.sources[0];
    return this.measureBizEntity;
  }

   private extractTargetBizEntities(relationshipData: IBizEntityRelationships[]): IBizEntity[] {
    const targetBizEntities: IBizEntity[] = [];
    relationshipData.forEach((relationship: IBizEntityRelationships) => {
      if (relationship.to && Array.isArray(relationship.to)) {
        relationship.to.forEach((to: IBizEntityRelationTarget) => {
          if (to.target.bizEntity) {
            targetBizEntities.push(to.target.bizEntity as IBizEntity);
          }
        });
      }
    });
    return targetBizEntities;
  }

  get measureBizEntityFormValues(): IMeasure {
      return this.populateMeasureFormWithValues();
    }

  private doesBizEntityHaveRelationship(): boolean {
    if (this.measureBizEntity?.type && this.measureBizEntity.type.relationshipConfiguration && this.measureBizEntity.type.relationshipConfiguration.length > 0) {
      this.relationshipConfigurations = this.measureBizEntity.type.relationshipConfiguration;
      return true;
    }
    return false;
  }

  onRelationshipFieldsChange(data: any): void {
  }

  onMeasureSave(): void {

    if(!this.isFormValid){
      this.toastService.toast("Please fill all the required fields");
      return ;
    }

    if (this.isAPICallInProgress) {
      this.toastService.toast('Please wait, operation in progress.');
      return;
    }

    this.setAPICallInProgress(true);
    this.populateMeasureFormWithValues();
    if (this.measureBizEntity && this.isFormValid) {
      if (this.isEditing) {
        this.measureStateStoreService.update(this.measureBizEntity)?.then(async (response) => {
          this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
          this.baseEntityFormComponent.afterSubmissionSucceeded();
          if (this.doesBizEntityHaveRelationship()) {
            await this.handleEditRelationships();
          }
          this.setAPICallInProgress(false);
        }).catch((error) => {
          this.toastService.toast('Error occured while updating measure');
          this.setAPICallInProgress(false);
        });
      } else {
        if(this.doesBizEntityHaveRelationship()){
          this.retrieveAdditionalEntityDetails();
        } else{
        this.measureStateStoreService.create(this.measureBizEntity)?.then((response) => {
          notifyStrategyEntityCreated(this.measureBizEntity, response, () => {
            this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
          });
          this.baseEntityFormComponent.afterSubmissionSucceeded();
          this.setAPICallInProgress(false);
        }).catch((error) => {
          this.toastService.toast('Error occured while creating measure');
          this.setAPICallInProgress(false);
        });
      }
      }
    } else {
      this.setAPICallInProgress(false);
    }
  }

  openFormFieldsModal(): void {
    const newField: IFieldMeta = {
      name: '',
      type: FieldTypes.text,
      label: '',
      isFilterable: false,
      isSearchable: false,
      isRequired: false,
      viewInList: false
    };

    const modalConfig = GetDefaultConfig();
    modalConfig.title = 'Add Field';
    modalConfig.dialog = ModalDialogs.AddNewField;
    modalConfig.model = { 'in': { fieldData: newField , isEditing: false, existingFields: this.measureBizEntity.logFieldsMeta }, 'out': null };
    modalConfig.footerButtons.push({
      id: ModalButtonIDs.Message_Cancel,
      label: 'Add Field',
      color: 'primary',
      click: ({ data, isFormFieldsValid }: { data: IFieldMeta, isFormFieldsValid: boolean }) => {
        // console.log("Data received from modal", data, isFormFieldsValid);
        if (!isFormFieldsValid) {
          this.toastService.toast('Please fill out all required fields.');
          return;
        }
        this.onNewFieldCreated(data);
      },
      isEnabled: ({ data, isFormFieldsValid }: { data: IFieldMeta, isFormFieldsValid: boolean }) => {
        return isFormFieldsValid;
      },
      getData: true,
      closesModal: true
    });
    this.modalService.show(modalConfig);
  }

  private onNewFieldCreated(data: IFieldMeta): void {
    if (this.measureBizEntity.logFieldsMeta) {
      this.measureBizEntity.logFieldsMeta = [...this.measureBizEntity.logFieldsMeta, data];
    } else {
      this.measureBizEntity.logFieldsMeta = [data];
    }
    this.initializeAdditionalFieldsListView();
  }

  onFieldDeleteClick(item: IListViewItem<IFieldMeta>): void {
    if(item?.data?.isSystemDefined || item?.data?.hiddenInForm){
      this.toastService.toast("System defined fields and hidden fields cannot be deleted.");
      return;
    }
    if (this.measureBizEntity?.logFieldsMeta && item.data) {
      const index = this.measureBizEntity.logFieldsMeta.findIndex(f => f.name === item.data?.name);
      if (index > -1) {
        this.measureBizEntity.logFieldsMeta.splice(index, 1);
        // Update the list view
        this.additionalFieldsListView = getAdditionalFieldsListView(
          this.measureBizEntity.logFieldsMeta,
          (item) => this.onFieldSettingsClick(item),
          (item) => this.onFieldDeleteClick(item)
        );
      }
    }
  }

  onFieldSettingsClick(item: IListViewItem<IFieldMeta>): void {
    if (!item.data) return;
    if(item.data.isSystemDefined || item.data.hiddenInForm){
      this.toastService.toast("System defined fields and hidden fields cannot be edited.");
      return;
    }
    const index = this.measureBizEntity.logFieldsMeta?.findIndex(f => f.name === item.data?.name) || -1;
    const modalConfig = GetDefaultConfig();
    modalConfig.title = 'Edit Field';
    modalConfig.dialog = ModalDialogs.AddNewField;
    modalConfig.model = { 
      'in': { 
        fieldData: item.data, 
        isEditing: true, 
        existingFields: this.measureBizEntity.logFieldsMeta || []
      }, 
      'out': null 
    };
    modalConfig.footerButtons.push({
      id: ModalButtonIDs.Measure_Fields_Save,
      label: 'Update',
      color: 'primary',
      isEnabled: ({ data, isFormFieldsValid }: { data: IFieldMeta, isFormFieldsValid: boolean }) => isFormFieldsValid,
      click: ({ data, isFormFieldsValid }: { data: IFieldMeta, isFormFieldsValid: boolean }) => {
        if (!isFormFieldsValid) {
          this.toastService.toast('Please fill out all required fields.');
          return;
        }
        if (index > -1 && this.measureBizEntity.logFieldsMeta) {
          this.measureBizEntity.logFieldsMeta[index] = data;
          this.initializeAdditionalFieldsListView();
        }
      },
      getData: true,
      closesModal: true
    });
    this.modalService.show(modalConfig);
  }

  fieldTrashClicked(index: number): void {
    if (this.measureBizEntity?.logFieldsMeta && this.measureBizEntity.logFieldsMeta.length > index) {
      this.measureBizEntity.logFieldsMeta.splice(index, 1);
      // Update the list view
      this.additionalFieldsListView = getAdditionalFieldsListView(
        this.measureBizEntity.logFieldsMeta,
        (item) => this.onFieldSettingsClick(item),
        (item) => this.onFieldDeleteClick(item)
      );
    }
  }

  openFieldManageDialog(field: IFieldMeta, index: number): void {
    // TODO: Implement field settings dialog
    // This could open a modal to edit field properties like name, type, icon, etc.
  }

  
  getTargetBizEntity(config: IRelationshipConfiguration): IBizEntity[] {
    if(!this.extractedTargetBizEntities || this.extractedTargetBizEntities.length === 0){
      return [];
    }
    if (config?.targetType === RelationshipTargetType.BizEntityType) {
      const res = this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.id.toString() === (config.target as IBizEntityType).id.toString() || 
                     bizEntity.type?.basedOnTypeId?.toString() === (config.target as IBizEntityType).id?.toString()
      );
      return res;
    } else {
      return this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.category === (config.target as BizEntityTypeCategory)
      );
    }
  }

  onBizEntityAdditionalInfo(data: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}[], index: number): void {
    // Since the component now emits an array of blocks/selections for each relationship config,
    // we need to flatten and store all entries. Remove old entries for this config first.
    this.relationshipAdditionalInfo = this.relationshipAdditionalInfo.filter(
      item => item.config !== data[0]?.config
    );
    // Add all new entries
    this.relationshipAdditionalInfo.push(...data);
  }

     onBizEntityAdditionalInfoForEdit(data: {config: IRelationshipConfiguration, bizEntity: IBizEntity}){
      this.relationshipAdditionalInfoForEdit.push(data);
    }

  private async handleEditRelationships(): Promise<void> {
    this.relationshipFieldsComponents?.forEach(rf => rf.getRelationshipFormFieldValues());
    if (this.relationshipAdditionalInfo.length === 0) return;

    const registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
    for (const data of this.relationshipAdditionalInfo) {
      if (data.config.targetType !== RelationshipTargetType.BizEntityType) continue;
      if (!this.measureBizEntity) continue;

      if (data.config.link === RelationshipLinkType.Tight) {
        const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.measureBizEntity);
        const tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.measureBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
        const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
        (tightlyLinkedBizEntity as IMeasure & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IMeasure).appId;
        (tightlyLinkedBizEntity as IMeasure & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IMeasure).tenantId;
        const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
        registeredRelationshipRecords.push({
          relationshipType: data.config.relationshipType,
          target: { isNew: true, bizEntity: transformedTightlyLinked, category: tightlyLinkedCategory },
        });
      } else {
        data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
          if (addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value) {
            const bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(be => be.id.toString() === addInfo.value.toString());
            if (bizEntity) {
              registeredRelationshipRecords.push({
                relationshipType: data.config.relationshipType,
                target: { isNew: false, bizEntity: bizEntity.id, category: bizEntity?.type?.category },
              });
            }
          }
        });
      }
    }

    if (registeredRelationshipRecords.length === 0) return;

    const relations: IBizEntityRelationships = {
      from: { isNew: false, bizEntity: this.measureBizEntity.id, category: this.measureBizEntity.type.category },
      to: registeredRelationshipRecords,
    };
    await this.relationshipStateStoreService.create(relations, false)?.catch((error) => {
      this.toastService.toast(`Error updating relationships: ${error}`);
    });
  }

     async retrieveAdditionalEntityDetails(){
      if(!this.doesBizEntityHaveRelationship()){
        return;
      }

      if(this.isRelationshipAdditionalInfoValid()){
        // if(this.isFormValid){
          if(!this.isEditing){
            let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
            for (const data of this.relationshipAdditionalInfo) {
              let targetType = data.config.targetType;
              if(targetType === RelationshipTargetType.BizEntityType)
              {
                if(!this.measureBizEntity){ continue;}
                if(data.config.link === RelationshipLinkType.Tight){
                  const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.measureBizEntity);
                  let tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.measureBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
                  const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
                  (tightlyLinkedBizEntity as IMeasure & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IMeasure).appId;
                  (tightlyLinkedBizEntity as IMeasure & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IMeasure).tenantId;
                  const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
                  registeredRelationshipRecords.push({
                    relationshipType: data.config.relationshipType,
                    target:{
                      isNew:true,
                      bizEntity: transformedTightlyLinked,
                      category: tightlyLinkedCategory
                    },
                  });
                } else{
                  // let bizEntity = this.benBizEntites.find(bizEntity => bizEntity.id.toString() === data.additionalInfo[0].value.toString());
                  data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
                    if(addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value){
                      let bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(bizEntity => bizEntity.id.toString() === addInfo.value.toString());
                      if(bizEntity){
                        registeredRelationshipRecords.push({
                          relationshipType: data.config.relationshipType,
                          target:{
                            isNew:false,
                            bizEntity: bizEntity.id,
                            category: bizEntity?.type.category
                          },
                        });
                      }
                    }
                  });
                  // if(bizEntity){
                  //   registeredRelationshipRecords.push({
                  //     relationshipType: data.config.relationshipType,
                  //     target:{
                  //       isNew:false,
                  //       bizEntity: bizEntity.id,
                  //       category: bizEntity?.type.category
                  //     },
                  //   });
                  // }
                }
              }
            }
            (this.measureBizEntity as IBenBizEntity & { appId?: string; tenantId?: string }).appId = (this.measureBizEntity as IMeasure).appId;
            (this.measureBizEntity as IBenBizEntity & { appId?: string; tenantId?: string }).tenantId = (this.measureBizEntity as IMeasure).tenantId;
            const transformedBizEntity = measureDataSyncBeforeSendingToAPI(this.measureBizEntity as IMeasure, this.userContextService);
            let relations: IBizEntityRelationships = {
              from:{
                isNew: true,
                bizEntity: transformedBizEntity,
                category: (this.measureBizEntity!).type.category
              },
              to: registeredRelationshipRecords,
            }
            this.relationshipStateStoreService.create(relations, false)?.then((response)=>{
                notifyStrategyEntityCreated(this.measureBizEntity, response, () => {
                  this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
                });
                this.baseEntityFormComponent.afterSubmissionSucceeded();
                this.setAPICallInProgress(false);
            }).catch((error) => {
              this.toastService.toast(`Error creating relationships: ${error}`);
              this.setAPICallInProgress(false);
            });
          }
          else{
            this.setAPICallInProgress(false);
            // let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
            // this.relationshipAdditionalInfoForEdit.forEach((data: {config: IRelationshipConfiguration, bizEntity: IBizEntity}) => {
            //   registeredRelationshipRecords.push({
            //     relationshipType: data.config.relationshipType,
            //     target: {
            //       isNew: false,
            //       bizEntity: data.bizEntity?.id || '',
            //       category: data.bizEntity?.type?.category!
            //     },
            //   });
            // });
            // let relations: IBizEntityRelationships = {
            //   from:{
            //     isNew: false,
            //     bizEntity: this.bizEntity?.id || '',
            //     category: this.bizEntity?.type?.category!
            //   },
            //   to: registeredRelationshipRecords,
            // }
            // console.log("this.relationshipAdditionalInfoForEdit", relations);
            // // this.relationshipStateStoreService.update(relations, this.userService);
          }
        // }
      }
      else{
        this.toastService.toast('Please provide all the fields of the related entity Biz Entity.');
        this.setAPICallInProgress(false);
      }
    }

  private setAPICallInProgress(inProgress: boolean): void {
    this.isAPICallInProgress = inProgress;
    //TO Do : This diable/enable the submit button in the footer should be handled using key instead of index 0
   if (this.formFooterLayout && this.formFooterLayout.footer && this.formFooterLayout.footer.actions.length > 0) {
    this.formFooterLayout.footer.actions[0].isDisabled = inProgress;
  }
  }

  isRelationshipAdditionalInfoValid(): boolean {
    // Trigger all relationship field components to emit their data
    this.relationshipFieldsComponents.forEach(relationshipField => {
      relationshipField.getRelationshipFormFieldValues();
    });

    let isValid = true;
    this.relationshipAdditionalInfo.forEach((data: {config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[]}) => {
      data.additionalInfo.forEach((addInfo: IAdditionalInfo) => {
        if (addInfo.fieldMeta.isRequired && !addInfo.value) {
          isValid = false;
          return;
        }
      });
    });

    return isValid;
  }

  private getDisciplineOptions() {
    const iconMap: Record<Discipline, string> = {
      [Discipline.SoftwareEngineering]: 'cilCode',
      [Discipline.Sales]: 'cilDollar',
      [Discipline.Marketing]: 'cilMegaphone',
      [Discipline.HumanResource]: 'cilPeople'
    };

    return Object.entries(Discipline).map(([key, value]) => ({
      id: key,
      label: value,
      icon: iconMap[value] || 'cilFolder'
    }));
  }

  private getGroupOptions() {
    const iconMap: Record<categoriesMenuLabel, string> = {
      [categoriesMenuLabel.Categories]: 'cilTags',
      [categoriesMenuLabel.Sources]: 'cilCloudDownload',
      [categoriesMenuLabel.Groups]: 'cilLibrary'
    };

    return Object.entries(categoriesMenuLabel).map(([key, value]) => ({
      id: key,
      label: value,
      icon: iconMap[value] || 'cilLibrary'
    }));
  }

  private getSubGroupOptions() {
    const iconMap: Record<groupsMenuItems, string> = {
      [groupsMenuItems.Retrospective]: 'cilReload',
      [groupsMenuItems.Sprint]: 'cilSpeedometer',
      [groupsMenuItems.ReviewCollaboration]: 'cilCommentSquare',
      [groupsMenuItems.Code]: 'cilCode',
      [groupsMenuItems.TeamHealth]: 'cilPeople',
      [groupsMenuItems.AllItems]: 'cilList'
    };

    return Object.entries(groupsMenuItems).map(([key, value]) => ({
      id: key,
      label: value,
      icon: iconMap[value] || 'cilLayers'
    }));
  }

  private getCategoryOptions() {
    const iconMap: { [key in KPIAndMeasureCategories]?: string } = {
      [KPIAndMeasureCategories.Progress]: 'cilArrowTop',
      [KPIAndMeasureCategories.Performance]: 'cilSpeedometer',
      [KPIAndMeasureCategories.Quality]: 'cilStar',
      [KPIAndMeasureCategories.Innovation]: 'cilLightbulb',
      [KPIAndMeasureCategories.Composite]: 'cilPuzzle',
      [KPIAndMeasureCategories.Misc]: 'cilLayers',
      [KPIAndMeasureCategories.Historical_Progress]: 'cilChart',
      [KPIAndMeasureCategories.Placeholder_2]: 'cilCircle',
      [KPIAndMeasureCategories.Placeholder_3]: 'cilCircle'
    };

    return Object.keys(KPIAndMeasureCategories)
      .filter(key => isNaN(Number(key)))
      .map(key => {
        const enumValue = KPIAndMeasureCategories[key as keyof typeof KPIAndMeasureCategories];
        return {
          id: key,
          label: key,
          icon: iconMap[enumValue] || 'cilTags'
        };
      });
  }

  async getEntityParentIdForTightlyLinkedEntity(config: IRelationshipConfiguration, currentEntity: IBizEntity): Promise<string | undefined> {
    if(config?.targetType === RelationshipTargetType.BizEntityType){
      const targetBizEntityTypeAppId = (config.target as IBizEntityType).appId;
      if(targetBizEntityTypeAppId && this.currentAppId !== targetBizEntityTypeAppId){
        // const tenants = await this.tenantStateStoreService.fetch();
        // const tenant = tenants?.[0];
        // return tenant?.id;
        const xappCap = {
          appId: targetBizEntityTypeAppId,
        }

        const appRootEntity = await this.appRootStateStoreService.get(undefined, undefined, xappCap);
        return appRootEntity?.id?.toString();
      }
      return currentEntity.parentId?.toString();
    }
    return undefined;
  }
}

// TODO: @mudit-OptimaStride This is a temporary hardcoded list item that needs to be replaced with dynamic data from the new form when DQR is implemented
const defaultStatusMeasureLogFieldsMeta: IFieldMeta = {
    "name": "status",
    "type": FieldTypes.number,
    "label": "status",
    "isFilterable": true,
    "isSearchable": true,
    "isRequired": true,
    "viewInList": true,
    "icon": "cilCalculator",
    "hiddenInForm": false,
    "validationMessages": []
}
